const INITIAL_STATE = {
  data: {},
  errors: {},
}
  
const getWorkOrderFilterList = (state = INITIAL_STATE, action) => {
  switch (action.type) {
  case 'GET_WORK_ORDER_FILTER':
    return { ...state, ...INITIAL_STATE, data: action.data }
  case 'GET_WORK_ORDER_FILTER_FAILED':
    return { ...state, ...INITIAL_STATE, errors: action.data }
  default:
    return { ...state }
  }
};
  
export default getWorkOrderFilterList;
  